<template>
  <v-container>
    <v-row
      class="mt-4 mb-2 d-flex justify-space-around align-center"
      style="background-color:white"
      :style="{
        'border-radius': open ? '25px 25px 0px 0px' : '50px',
        'background-color': open ? '#637f43' : 'white'
      }"
      @click="toggle()"
      @keypress="toggle()"
      role="button"
      tabindex="0"
      :title="'查看' + title"
      :aria-label="'查看' + title"
      :aria-expanded="String(open)"
    >
      <v-col
        cols="6"
        class="d-flex justify-start align-center"
        style="text-align:left"
        ><div class="my-auto" :style="{ color: open ? 'white' : 'black' }">
          {{ "Q：" + title }}
        </div>
      </v-col>
      <v-col> </v-col>
      <v-col cols="2" class="d-flex justify-end align-center">
        <div v-if="open">
          <!--           @click="toggle()"
          @keypress="toggle()"
          role="button"
          tabindex="0"
          title="收合" -->
          <v-icon color="white">mdi-chevron-down </v-icon>
        </div>
        <div v-else>
          <!--           @click="toggle()"
          @keypress="toggle()"
          role="button"
          tabindex="0"
          title="展開" -->
          <v-icon>mdi-chevron-up </v-icon>
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="open"
      style="background-color:white"
      :style="{ 'border-radius': open ? '0px 0px 25px 25px' : '50px' }"
    >
      <!-- <v-col cols="12">A：</v-col> -->
      <v-col cols="12" v-html="TOOL.replaceUnitToRem(content)"></v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      open: false,

      test: false
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
};
</script>
<style lang="scss" scoped></style>
